var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0004 14.55C40.2914 12.5991 39.3497 10.0936 39.3504 7.5H31.6254V38.5C31.5658 40.1776 30.8576 41.7665 29.6498 42.9323C28.442 44.0981 26.829 44.7498 25.1504 44.75C21.6004 44.75 18.6504 41.85 18.6504 38.25C18.6504 33.95 22.8004 30.725 27.0754 32.05V24.15C18.4504 23 10.9004 29.7 10.9004 38.25C10.9004 46.575 17.8004 52.5 25.1254 52.5C32.9754 52.5 39.3504 46.125 39.3504 38.25V22.525C42.4829 24.7746 46.2438 25.9816 50.1004 25.975V18.25C50.1004 18.25 45.4004 18.475 42.0004 14.55Z",
    fill: "#80FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "homepage/static/media/tiktok.223c577cf10f7409e27fc00310fc81b6.svg";
export { ForwardRef as ReactComponent };